import { v4 as uuidv4 } from 'uuid';
import axios, { AxiosError } from 'axios';
import { Api } from '../axiosApi';

export interface IOrdemServicoItem {
  iditem: string;
  idos: string;
  idproduto?: string;
  avulso: boolean;
  descricao: string;
  referencia?: string;
  unidade?: string;
  quantidade: number;
  valorunitario: number;
  desconto: number;
  total: number;
}

export interface ICreateOrdemServicoItem {
  idproduto?: string;
  avulso: boolean;
  descricao: string;
  referencia?: string;
  unidade?: string;
  quantidade: number;
  valorunitario: number;
  desconto: number;
}

interface ErrorResponse {
  errors: {
    default: string;
  };
}

const tratarErro = (error: unknown): Error => {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError<ErrorResponse>;
    if (axiosError.response) {
      return new Error(axiosError.response.data.errors?.default || 'Erro desconhecido');
    } else if (axiosError.request) {
      return new Error('Nenhuma resposta do servidor');
    } else {
      return new Error(axiosError.message);
    }
  }
  return new Error('Erro inesperado');
};

const create = async (idos: string, dados: ICreateOrdemServicoItem): Promise<IOrdemServicoItem | Error> => {
  try {
    const iditem = uuidv4();
    const total = dados.quantidade * dados.valorunitario - (dados.desconto || 0);
    await Api.post(`/ordemservico/${idos}/produtos`, { iditem, ...dados });
    return { iditem, idos, total, ...dados };
  } catch (error) {
    return tratarErro(error);
  }
};

const updateById = async (idos: string, iditem: string, dados: ICreateOrdemServicoItem): Promise<IOrdemServicoItem | Error> => {
  try {
    const total = dados.quantidade * dados.valorunitario - (dados.desconto || 0);
    await Api.put(`/ordemservico/${idos}/produtos/${iditem}`, dados);
    return { iditem, idos, total, ...dados };
  } catch (error) {
    return tratarErro(error);
  }
};

const deleteById = async (idos: string, iditem: string): Promise<void | Error> => {
  try {
    await Api.delete(`/ordemservico/${idos}/produtos/${iditem}`);
  } catch (error) {
    return tratarErro(error);
  }
};

export const OrdemServicoProdutosService = {
  create,
  updateById,
  deleteById,
};
